export class OrganizationEntity {
  id: string;
  email: string;
  userPrincipalName: string;
  displayName: string;
  name: string;
  lastName?: string | null; // Cho phép lastName là null hoặc không có
  jobTitle?: string | null;
  department: string;
  office?: string | null;
  businessPhones: string;
  faxNumber: string;
  mobilePhone: string;
  streetAddress: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
  countryOrRegion: string;
  organizationId?: string | null;

  constructor(data: IOrganizationEntity) {
    this.id = data.id;
    this.email = data.email;
    this.userPrincipalName = data.userPrincipalName;
    this.displayName = data.displayName;
    this.name = data.name;
    this.lastName = data.lastName;
    this.jobTitle = data.jobTitle;
    this.department = data.department;
    this.office = data.office;
    this.businessPhones = data.businessPhones;
    this.faxNumber = data.faxNumber;
    this.mobilePhone = data.mobilePhone;
    this.streetAddress = data.streetAddress;
    this.city = data.city;
    this.stateOrProvince = data.stateOrProvince;
    this.zipOrPostalCode = data.zipOrPostalCode;
    this.countryOrRegion = data.countryOrRegion;
    this.organizationId = data.organizationId;
  }
}

export interface IOrganizationEntity {
  id: string;
  email: string;
  userPrincipalName: string;
  displayName: string;
  name: string;
  lastName?: string | null;
  jobTitle?: string | null;
  department: string;
  office?: string | null;
  businessPhones: string;
  faxNumber: string;
  mobilePhone: string;
  streetAddress: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
  countryOrRegion: string;
  organizationId?: string | null;
}

export interface IFetchRequest {
  orgId: string;
  tenantId: string;
}